import { Button, CardHeader, CardHeaderTypeMap, Divider, Grid, IconButton } from "@mui/material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloseIcon from '@mui/icons-material/Close';
import { Help, Info, InfoTwoTone } from "@mui/icons-material";

type ExtensionProps = {
    title?: string;
    divider?: boolean;
    subcard?: boolean;
    centerlabel?: boolean;
    className?: string;
    onDelete?:()=>void;
    onClose?:()=>void; 
    onCommand?:()=>void;
    onInfo?:()=>void;
    onCommandText?: string;
    disableDelete?: boolean;
    visibleDelete?: boolean;
}


export const SectionHeader: React.FC<Partial<CardHeaderTypeMap> & ExtensionProps> = (
    {
        title,
        divider,
        subcard,
        centerlabel,
        className,
        onDelete,
        onClose,
        onInfo,
        onCommand,
        onCommandText,
        disableDelete,
        visibleDelete,
        ...rest
    }

) =>
{
    var _className = (className ?? "") + " " + (subcard && !centerlabel ? "sub-header" : "main-header")

    if(subcard) {
        _className += " no-shadow";
    }


    return (
        <>
            {/*Card Header*/}
            {title && (

                <CardHeader
                    className={_className}
                    title={title}
                    titleTypographyProps={{ variant: 'subtitle1', className: subcard ? "sub-header-label" : "card-header-label"}}
                    action={onDelete && visibleDelete  && <IconButton color="error" disabled={disableDelete} onClick={onDelete}><DeleteOutlineIcon/></IconButton>
                             || onClose && <IconButton onClick={onClose}><CloseIcon/></IconButton>
                             || onInfo && <IconButton onClick={onInfo}><Info color="info" /></IconButton>
                             || onCommand && <Button variant="text" onClick={onCommand} aria-label={onCommandText}>{onCommandText}</Button>
                            }  
                    {...rest }
                    
                />
            )}
            {title && divider && <Divider className="header-divider" />}
        </>
    )
}